var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//region import

// models
import model from '../base.model';
import { loginModel } from '../auth/login.model';
import { deviceModel } from './device.model';

// storage
import { getServerUrl as settingsGetServerUrl } from '../../device/settings.storage';

// constants
import urls from '../../constants/urls.constant';
import { config } from '../../config/apiConfig';

// utils
import { tstToDate, returnPromise, roundNumber } from '../../utils/helpers';
import { mergeItems, getInfoByStatus, isOldData, getOldDataCount } from '../../services/core/control/control.helper';

//endregion


class controlModel extends model {
    //region init

    constructor(props) {
        super(props);
    }

    static create() {
        return _extends({}, super.create(), {
            items: [],
            power: {
                isLoading: false,
                status: {
                    isLoading: false,
                    Ch: null
                },
                value: 0,
                time: null
            },
            powerLimits: {
                isLoading: false,
                maxPower: 0,
                maxOverload: 0
            },
            oldData: {
                count: 0,
                isOldData: false
            }
        });
    }

    //endregion
    //region model

    static processServerResponse(dispatch, params, model, serverResponse, history) {}

    static isClientEmpty(clientModel) {
        return !clientModel || !clientModel.items || !clientModel.items.length;
    }

    static getReduceMethod(model, type) {
        const reduceMethod = super.getReduceMethod(model, type);
        if (reduceMethod) {
            return reduceMethod;
        }
        const reducers = {
            [model.TYPE_GET_POWER]: model.reduceGetPower.bind(model),
            [model.TYPE_REQUEST_POWER]: model.reduceRequestDevicesPowerSum.bind(model),
            [model.TYPE_GET_STATUS]: model.reduceGetStatus.bind(model),
            [model.TYPE_REQUEST_STATUS]: model.reduceRequestDevicesStatus.bind(model),
            [model.TYPE_GET_DEVICES_POWER_LIMITS]: model.reduceGetDevicesPowerLimits.bind(model),

            // device
            [deviceModel.TYPE_REQUEST_DEVICE_DATA]: model.reduceUpdateDeviceRequest.bind(model),
            [deviceModel.TYPE_DEVICE_DATA]: model.reduceUpdateDevice.bind(model),

            [deviceModel.TYPE_REQUEST_DEVICE_ENERGY_CHART_DATA]: model.reduceUpdateDeviceRequest.bind(model),
            [deviceModel.TYPE_DEVICE_ENERGY_CHART_DATA]: model.reduceUpdateDevice.bind(model),

            [deviceModel.TYPE_REQUEST_DEVICE_STATUS]: model.reduceUpdateDeviceRequest.bind(model),
            [deviceModel.TYPE_DEVICE_STATUS]: model.reduceUpdateDevice.bind(model),

            [deviceModel.TYPE_REQUEST_DEVICE_POWER]: model.reduceUpdateDeviceRequest.bind(model),
            [deviceModel.TYPE_DEVICE_POWER]: model.reduceUpdateDevice.bind(model),

            [deviceModel.TYPE_REQUEST_DEVICE_ENERGY]: model.reduceUpdateDeviceRequest.bind(model),
            [deviceModel.TYPE_DEVICE_ENERGY]: model.reduceUpdateDevice.bind(model),

            [deviceModel.TYPE_REQUEST_SET_DEVICE_STATUS]: model.reduceUpdateDeviceRequest.bind(model),
            [deviceModel.TYPE_SET_DEVICE_STATUS]: model.reduceUpdateDevice.bind(model)
        };

        return reducers[type];
    }

    //endregion
    //region api get devices power limits

    static apiGetDevicesPowerLimits(clientApiMethod, params = {}, dispatch, failAction) {
        var _this = this;

        return _asyncToGenerator(function* () {
            const serverModel = _this.mapDevicesPowerLimitsToServer(params);
            const { urlParams } = serverModel;
            const authData = yield loginModel.storageGetAuthToken(loginModel);
            const { authToken } = authData;
            const serverUrl = yield settingsGetServerUrl();
            const url = urls.core.getDevicesPowerLimits();

            return returnPromise({
                max_power: 8500,
                max_overload: 10000
            });
        })();
    }

    static processGetDevicesPowerLimits(dispatch, params, model, serverResponse, history) {
        const modelClient = this.mapDevicesPowerLimits(serverResponse);
        dispatch(this.actionGetDevicesPowerLimits(this, { modelClient, model: this }));
    }

    static mapDevicesPowerLimits(serverModel) {
        if (!serverModel) {
            return {
                powerLimits: this.create().powerLimits
            };
        }

        return {
            powerLimits: {
                maxPower: +serverModel.max_power,
                maxOverload: +serverModel.max_overload
            }
        };
    }

    static mapDevicesPowerLimitsToServer(clientModel) {
        if (super.isEmpty(clientModel)) {
            return {};
        }

        return {
            urlParams: {}
        };
    }

    static actionGetDevicesPowerLimits(model, payload) {
        return dispatch => {
            dispatch({
                type: model.TYPE_GET_DEVICES_POWER_LIMITS,
                payload
            });
        };
    }

    static reduceGetDevicesPowerLimits(stateModel, action) {
        const { modelClient, model } = action.payload;
        const {
            powerLimits
        } = modelClient;

        return {
            [model.MODEL_NAME]: _extends({}, stateModel, {
                isLoading: false,
                powerLimits
            })
        };
    }

    //endregion
    //region api get devices power sum

    static apiGetDevicesPowerSum(clientApiMethod, params = {}, dispatch, failAction) {
        var _this2 = this;

        return _asyncToGenerator(function* () {
            const serverModel = _this2.mapDevicesPowerSumToServer(params);
            const { urlParams } = serverModel;
            const authData = yield loginModel.storageGetAuthToken(loginModel);
            const { authToken } = authData;
            const serverUrl = yield settingsGetServerUrl();
            const url = urls.core.getDevicesPowerSum();

            dispatch(_this2.actionRequestDevicesPowerSum(_this2, { modelClient: { isLoading: true }, model: _this2 }));

            return clientApiMethod(serverUrl, url, serverModel.payload, authToken);
        })();
    }

    static processGetDevicesPowerSum(dispatch, params, model, serverResponse, history) {
        const serverModel = this.mapDevicesPowerSumToServer(params);
        const modelClient = this.mapDevicesPowerSumToClient(serverResponse, serverModel.items);
        dispatch(this.actionGetDevicesPowerSum(this, { modelClient, model: this }));
    }

    static requestGetDevicesPowerSum(dispatch, params, model, serverResponse, history) {
        dispatch(this.actionRequestDevicesPowerSum(this, { modelClient: { isLoading: false }, model: this }));
    }

    static actionRequestDevicesPowerSum(model, payload) {
        return {
            type: model.TYPE_REQUEST_POWER,
            payload
        };
    }

    static reduceRequestDevicesPowerSum(stateModel, action, state) {
        const { modelClient, model } = action.payload;
        return {
            [model.MODEL_NAME]: _extends({}, stateModel, {
                power: _extends({}, stateModel.power, {
                    isLoading: modelClient.isLoading
                })
            })
        };
    }

    static mapDevicesPowerSumToClient(serverModel, itemsFromClient) {
        if (!serverModel || !serverModel.sum || !itemsFromClient) {
            return {
                power: this.create().power
            };
        }

        const items = itemsFromClient.filter(item => {
            return !!item.deviceId;
        }).map((item, index) => {
            const powerInfo = serverModel[`/me/${item.deviceId}/app/P`];
            return {
                deviceId: item.deviceId,
                power: powerInfo && {
                    status: powerInfo.status,
                    value: roundNumber(powerInfo.P.value),
                    time: powerInfo.time,
                    date: tstToDate(powerInfo.time)
                }
            };
        });

        return {
            items,
            power: {
                status: serverModel.sum.status,
                value: roundNumber(serverModel.sum.P.value),
                time: serverModel.sum.time
            }
        };
    }

    static mapDevicesPowerSumToServer(clientModel) {
        if (super.isEmpty(clientModel)) {
            return {};
        }

        return {
            urlParams: {},
            items: clientModel.items
        };
    }

    static actionGetDevicesPowerSum(model, payload) {
        return dispatch => {
            dispatch({
                type: model.TYPE_GET_POWER,
                payload
            });
        };
    }

    static reduceGetPower(stateModel, action) {
        const { modelClient, model } = action.payload;
        const {
            power,
            items
        } = modelClient;

        return {
            [model.MODEL_NAME]: _extends({}, stateModel, {
                isLoading: false,
                power: _extends({}, power),
                oldData: {
                    count: getOldDataCount(stateModel, power),
                    isOldData: isOldData(stateModel, power)
                },
                items: mergeItems(stateModel.items, items)
            })
        };
    }

    //endregion
    //region api get devices status

    static apiGetDevicesStatus(clientApiMethod, params = {}, dispatch, failAction) {
        var _this3 = this;

        return _asyncToGenerator(function* () {
            const serverModel = _this3.mapStatusToServer(params);
            const { urlParams } = serverModel;
            const authData = yield loginModel.storageGetAuthToken(loginModel);
            const { authToken } = authData;
            const serverUrl = yield settingsGetServerUrl();
            const url = urls.core.getDevicesStatus();

            dispatch(_this3.actionRequestDevicesStatus(_this3, { modelClient: { isLoading: true }, model: _this3 }));

            return clientApiMethod(serverUrl, url, serverModel.payload, authToken);
        })();
    }

    static processGetDevicesStatus(dispatch, params, model, serverResponse, history) {
        const serverModel = this.mapStatusToServer(params);
        const modelClient = this.mapStatusToClient(serverResponse, serverModel.items, serverModel.isOldData);
        dispatch(this.actionGetStatus(this, { modelClient, model: this }));
    }

    static requestGetDevicesStatus(dispatch, params, model, serverResponse, history) {
        dispatch(this.actionRequestDevicesStatus(this, { modelClient: { isLoading: false }, model: this }));
    }

    static actionRequestDevicesStatus(model, payload) {
        return {
            type: model.TYPE_REQUEST_STATUS,
            payload
        };
    }

    static reduceRequestDevicesStatus(stateModel, action, state) {
        const { modelClient, model } = action.payload;
        return {
            [model.MODEL_NAME]: _extends({}, stateModel, {
                power: _extends({}, stateModel.power, {
                    status: _extends({}, stateModel.power.status, {
                        isLoading: modelClient.isLoading
                    })
                })
            })
        };
    }

    static mapStatusToClient(serverModel, itemsFromClient, isOldData) {
        if (!serverModel || !itemsFromClient) {
            return {
                items: itemsFromClient
            };
        }

        const items = itemsFromClient.filter(item => {
            return !!item.deviceId;
        }).map((item, index) => {
            const statusInfo = serverModel[`/me/${item.deviceId}/app/Ch`];
            const { className, text, color } = getInfoByStatus(statusInfo.Ch && statusInfo.Ch.value, isOldData);
            return {
                deviceId: item.deviceId,
                status: {
                    Ch: statusInfo.Ch,
                    className,
                    text,
                    color
                }
            };
        });

        return {
            items
        };
    }

    static mapStatusToServer(clientModel) {
        if (super.isEmpty(clientModel)) {
            return {
                items: [],
                isOldData: false
            };
        }

        return {
            items: clientModel.items,
            isOldData: clientModel.isOldData
        };
    }

    static actionGetStatus(model, payload) {
        return dispatch => {
            dispatch({
                type: model.TYPE_GET_STATUS,
                payload
            });
        };
    }

    static reduceGetStatus(stateModel, action) {
        const { modelClient, model } = action.payload;
        const {
            items
        } = modelClient;

        return {
            [model.MODEL_NAME]: _extends({}, stateModel, {
                isLoading: false,
                items: mergeItems(stateModel.items, items)
            })
        };
    }

    //endregion
    //region api get device list

    static apiGet(clientApiMethod, params = {}, dispatch, failAction) {
        var _this4 = this;

        return _asyncToGenerator(function* () {
            const serverModel = _this4.mapToServer(params);
            const { urlParams } = serverModel;
            const authData = yield loginModel.storageGetAuthToken(loginModel);
            const { authToken } = authData;
            const serverUrl = yield settingsGetServerUrl();
            const url = urls.core.getDeviceList(urlParams); //getControlsStatus(urlParams);

            return clientApiMethod(serverUrl, url, serverModel.payload, authToken).then(function (serverResponse) {
                const modelClient = _this4.mapToClient(serverResponse);
                if (!modelClient.items) {
                    return;
                }

                const promises = modelClient.items.map(function (item) {
                    const params = { deviceId: item.name, isBatchCall: true };
                    return deviceModel.apiGetDeviceData.bind(deviceModel)(clientApiMethod, params, dispatch, failAction);
                });

                Promise.all(promises).then(function (controlsData) {
                    if (!controlsData) {
                        return;
                    }

                    modelClient.items = controlsData.map(function (control) {
                        return deviceModel.mapDeviceDataToClient(control);
                    });
                    dispatch(_this4.dispatchModel({ modelClient, model: _this4 }));
                }).catch(_this4.catchRequest(_this4, dispatch, failAction));
            });
        })();
    }

    static mapToClient(serverModel) {
        if (!serverModel || !serverModel.length) {
            return this.create();
        }

        const items = serverModel.map(this.toClientItem);
        return {
            items
        };
    }

    static mapToServer(clientModel) {
        if (super.isEmpty(clientModel)) {
            return {};
        }

        return {
            urlParams: {}
        };
    }

    static reduceGet(stateModel, action) {
        const { modelClient, model } = action.payload;
        const {
            items
        } = modelClient;

        return {
            [model.MODEL_NAME]: _extends({}, stateModel, {
                isLoading: false,
                items
            })
        };
    }

    //endregion
    //region update device

    static reduceUpdateDeviceRequest(stateModel, action) {
        const { modelClient, model } = action.payload;
        const {
            deviceId,
            dataKey,
            isLoading
        } = modelClient;

        let items = stateModel.items && stateModel.items.filter(i => i.deviceId === deviceId);
        if (items.length) {
            const item = items[0];
            item[dataKey] = _extends({}, item[dataKey], {
                isLoading
            });
            items = [_extends({}, item)];
        }

        return {
            [model.MODEL_NAME]: _extends({}, stateModel, {
                items: mergeItems(stateModel.items, items)
            })
        };
    }

    static reduceUpdateDevice(stateModel, action) {
        const { modelClient, model } = action.payload;
        const {
            deviceId
        } = modelClient;

        let items = stateModel.items && stateModel.items.filter(i => i.deviceId === deviceId);
        if (items.length) {
            items = [_extends({}, items[0], modelClient)];
        }

        return {
            [model.MODEL_NAME]: _extends({}, stateModel, {
                items: mergeItems(stateModel.items, items)
            })
        };
    }
}

controlModel.MODEL_NAME = 'controlModel';
controlModel.TYPE_REQUEST = 'REQUEST_CONTROLS';
controlModel.TYPE_FROM_SERVER = 'GET_CONTROLS';
controlModel.TYPE_CLEAR = 'CLEAR_CONTROLS';
controlModel.TYPE_UPDATE_DEVICE = 'TYPE_GET_CONTROLS_UPDATE_DEVICE';
controlModel.TYPE_GET_POWER = 'TYPE_GET_CONTROLS_SUM_POWER';
controlModel.TYPE_REQUEST_POWER = 'TYPE_REQUEST_CONTROLS_SUM_POWER';
controlModel.TYPE_GET_STATUS = 'TYPE_GET_CONTROLS_STATUS';
controlModel.TYPE_REQUEST_STATUS = 'TYPE_REQUEST_CONTROLS_STATUS';
controlModel.TYPE_GET_DEVICES_POWER_LIMITS = 'TYPE_GET_DEVICES_POWER_LIMITS';

controlModel.toClientItem = serverModelItem => {
    if (!serverModelItem) {
        return {};
    }

    return {
        name: serverModelItem,
        id: serverModelItem.replace("/me/", "").replace("/app/Ch", "")

    };
};

export { controlModel };


// WEBPACK FOOTER //
// ./~/pluton-core/lib/models/core/control.model.js